<div class="modal-header">
  <h5 class="modal-title">{{'advanceFilter' | translate}}</h5>
  <button type="button" class="close" style="cursor: pointer;" aria-label="Close" (click)="closeActiveModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <div class="row">

    <div class="col-sm-12 col-xs-12 col-md-4 col-lg-3">
      <div class="form-group row">
        <label class="col-sm-12 col-form-label">{{'fromDate' | translate}}</label>
        <div class="col-sm-12">
          <ngx-datepicker #fromDate class="form-control form-control-lg p-15" id="fromDate"
            [options]="fromDatePickeroptions" [(ngModel)]="selectedFilters.fromDate">

          </ngx-datepicker>
          <i *ngIf="selectedFilters.fromDate && selectedFilters.fromDate !==null"
            class="fa fa-times c-pointer clear-datepicker-icon" (click)="clearFromDate()"></i>
        </div>

      </div>
    </div>

    <div class="col-sm-12 col-xs-12 col-md-4 col-lg-3">
      <div class="form-group row">
        <label class="col-sm-12 col-form-label">{{'toDate' | translate}}</label>
        <div class="col-sm-12">
          <ngx-datepicker #toDate class="form-control form-control-lg p-15" id="toDate" [options]="toDatePickeroptions"
            [(ngModel)]="selectedFilters.toDate">

          </ngx-datepicker>
          <i *ngIf="selectedFilters.toDate && selectedFilters.toDate !==null"
            class="fa fa-times c-pointer clear-datepicker-icon" (click)="clearToDate()"></i>
        </div>

      </div>
    </div>


    <div class="col-sm-12 col-xs-12 col-md-4 col-lg-3">
      <div class="form-group">
        <label class="col-sm-12 col-form-label">{{'requestStatus' | translate}}</label>
        <div class="col-sm-12">
          <ng-select [(ngModel)]="selectedFilters.requestStatuses" [multiple]="true" [clearable]="false"
            placeholder="{{'pleaseSelectStatus' | translate}}" [hideSelected]="true">
            <ng-option *ngFor="let status of filterDetails.filteredRequestStatuses" [value]="status.id">
              {{lang==='ar'?status.altName:status.name}}</ng-option>
          </ng-select>
        </div>

      </div>
    </div>


 
  


  </div>
</div>
<div class="modal-footer">
  <button type="button" (click)="applyFilter()" class="btn btn-primary"> <i class="icon-check pl-1 pr-1"></i>{{'apply'
    | translate }}</button>


  <button (click)="closeActiveModal()" type="button" class="btn btn-light"><i
      class="icon-close menu-icon pl-1 pr-1"></i>{{'cancel' | translate
    }}</button>
</div>
